module.exports = __webpack_public_path__ + "img/join-us-title.034748cd.svg";